<template>
  <div v-if="show" class="content-spinner d-flex flex-column text-info"
       :style="{'min-height': `${height}em`}" :class="`${spinnerClass}`">
    <b-spinner class="align-middle" :style="{height: `${spinnerSize}rem`, width: `${spinnerSize}rem`}"/>
    <strong v-if="withText" class="mt-2" :style="{'font-size': `${fontSize}rem`}">
      {{ text }}
    </strong>
  </div>
</template>

<script>
  export default {
    name: "Spinner",
    data() {
      return {};
    },
    props: {
      show: {
        type: Boolean,
        default: false
      },
      height: {
        type: [Number, String],
        default: 1
      },
      withText: {
        type: Boolean,
        default: true
      },
      spinnerSize: {
        type: [Number, String],
        default: 2
      },
      spinnerClass: {
        type: String,
        default: "my-2 justify-content-center align-items-center"
      },
      fontSize: {
        type: [Number, String],
        default: 0.85
      },
      text: {
        type: String,
        default: function() {
          return this.$i18n.t("Loading...")
        }
      }
    },
    computed: {},
    methods: {}
  }
</script>

<style lang="scss" scoped>

</style>
